<div class="basket-audit-hub">
  <div class="row mb-4 align-items-center">
    <div class="col-md-8">
      <h4>Basket Audit &amp; Scan Insights</h4>
      <p class="text-muted mb-0">
        POS basket modifications and scan/clear analytics for theft-prevention monitoring.
      </p>
    </div>
  </div>

  <nb-card class="mb-4">
    <nb-card-body class="p-0">
      <nav class="nav nav-tabs custom-tabs section-tabs">
        <a
          class="nav-link"
          [class.active]="activeSection === 'audit-trail'"
          (click)="setSection('audit-trail')"
          href="javascript:void(0)">
          <nb-icon icon="shield-outline" class="me-2"></nb-icon>
          Audit Trail
        </a>
        <a
          class="nav-link"
          [class.active]="activeSection === 'scan-insights'"
          (click)="setSection('scan-insights')"
          href="javascript:void(0)">
          <nb-icon icon="bar-chart-outline" class="me-2"></nb-icon>
          Scan &amp; Basket Insights
        </a>
      </nav>
    </nb-card-body>
  </nb-card>

  <app-basket-audit
    *ngIf="activeSection === 'audit-trail'"
    [storeId]="storeId">
  </app-basket-audit>

  <app-scan-insights
    *ngIf="activeSection === 'scan-insights'"
    [storeId]="storeId">
  </app-scan-insights>
</div>
